// /**
//  * Cart Limit Validator
//  * Validates cart quantities against metaobject profiles and product metafields
//  */

// class CartLimitValidator {
//   constructor() {
//     this.profiles = null;
//     this.currentCart = null;
//   }

//   /**
//    * Fetch active cart limit profiles from metaobjects
//    */
//   async fetchCartLimitProfiles() {
//     const query = `
//       query {
//         metaobjects(type: "cart_limit_profile", first: 50) {
//           nodes {
//             id
//             fields {
//               key
//               value
//               reference {
//                 ... on Product {
//                   id
//                   handle
//                 }
//               }
//               references(first: 100) {
//                 nodes {
//                   ... on Product {
//                     id
//                     handle
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     `;

//     try {
//       const response = await fetch('/api/2024-10/graphql.json', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Shopify-Storefront-Access-Token': window.Shopify?.storefrontAccessToken || '',
//         },
//         body: JSON.stringify({ query }),
//       });

//       const data = await response.json();
//       this.profiles = this.parseProfiles(data.data.metaobjects.nodes);
//       return this.profiles;
//     } catch (error) {
//       console.error('Error fetching cart limit profiles:', error);
//       return [];
//     }
//   }

//   /**
//    * Parse metaobject nodes into usable profile objects
//    */
//   parseProfiles(nodes) {
//     return nodes
//       .map(node => {
//         const profile = {};
//         node.fields.forEach(field => {
//           if (field.key === 'name') {
//             profile.name = field.value;
//           } else if (field.key === 'is_active') {
//             profile.isActive = field.value === 'true';
//           } else if (field.key === 'limit_type') {
//             profile.limitType = field.value;
//           } else if (field.key === 'max_quantity') {
//             profile.maxQuantity = parseInt(field.value, 10);
//           } else if (field.key === 'products') {
//             profile.products = field.references?.nodes.map(p => p.id) || [];
//           }
//         });
//         return profile;
//       })
//       .filter(profile => profile.isActive); // Only return active profiles
//   }

//   /**
//    * Fetch current cart state
//    */
//   async fetchCart() {
//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();
//       this.currentCart = cart;
//       return cart;
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       return { items: [] };
//     }
//   }

//   /**
//    * Validate if adding a product would exceed limits
//    * @param {string} variantId - The variant ID being added
//    * @param {number} quantityToAdd - Quantity being added
//    * @param {string} productId - Product GID (e.g., gid://shopify/Product/123)
//    * @param {number} fallbackMaxQuantity - ri_max_quantity from product metafield
//    * @returns {Object} { valid: boolean, error: string|null }
//    */
//   async validate(variantId, quantityToAdd, productId, fallbackMaxQuantity = null) {
//     // Fetch profiles and cart if not already loaded
//     if (!this.profiles) {
//       await this.fetchCartLimitProfiles();
//     }
//     if (!this.currentCart) {
//       await this.fetchCart();
//     }

//     // Find matching profiles for this product
//     const productProfiles = this.profiles.filter(profile => {
//       if (profile.limitType === 'per_product') {
//         return profile.products.includes(productId);
//       }
//       return false;
//     });

//     // Check per-product limits
//     if (productProfiles.length > 0) {
//       // Use the strictest (lowest) limit if multiple profiles apply
//       const strictestLimit = Math.min(...productProfiles.map(p => p.maxQuantity));
      
//       // Calculate current quantity of this product in cart
//       const currentQuantity = this.currentCart.items
//         .filter(item => item.product_id === this.extractNumericId(productId))
//         .reduce((sum, item) => sum + item.quantity, 0);

//       const newTotal = currentQuantity + quantityToAdd;

//       if (newTotal > strictestLimit) {
//         return {
//           valid: false,
//           error: `Cannot add ${quantityToAdd} item(s). Maximum ${strictestLimit} allowed for this product. You currently have ${currentQuantity} in your cart.`
//         };
//       }
//     } 
//     // Fall back to ri_max_quantity metafield if no profile exists
//     // else if (fallbackMaxQuantity) {
//     //   const currentQuantity = this.currentCart.items
//     //     .filter(item => item.product_id === this.extractNumericId(productId))
//     //     .reduce((sum, item) => sum + item.quantity, 0);

//     //   const newTotal = currentQuantity + quantityToAdd;

//     //   if (newTotal > fallbackMaxQuantity) {
//     //     return {
//     //       valid: false,
//     //       error: `Cannot add ${quantityToAdd} item(s). Maximum ${fallbackMaxQuantity} allowed for this product. You currently have ${currentQuantity} in your cart.`
//     //     };
//     //   }
//     // }

//     // Check total cart limit
//     const totalCartProfile = this.profiles.find(profile => profile.limitType === 'total_cart');
//     if (totalCartProfile) {
//       const currentTotalQuantity = this.currentCart.items.reduce((sum, item) => sum + item.quantity, 0);
//       const newTotal = currentTotalQuantity + quantityToAdd;

//       if (newTotal > totalCartProfile.maxQuantity) {
//         return {
//           valid: false,
//           error: `Cannot add ${quantityToAdd} item(s). Maximum ${totalCartProfile.maxQuantity} total items allowed in cart. You currently have ${currentTotalQuantity} items.`
//         };
//       }
//     }

//     return { valid: true, error: null };
//   }

//   /**
//    * Extract numeric ID from Shopify GID
//    * gid://shopify/Product/123 => 123
//    */
//   extractNumericId(gid) {
//     if (!gid) return null;
//     const parts = gid.split('/');
//     return parseInt(parts[parts.length - 1], 10);
//   }

//   /**
//    * Reset cached data (useful if cart changes externally)
//    */
//   reset() {
//     this.profiles = null;
//     this.currentCart = null;
//   }
// }

// // Export singleton instance
// window.cartLimitValidator = new CartLimitValidator();












/**
 * Cart Limit Validator
 * Validates cart quantities against metaobject profiles and product metafields
 */

class CartLimitValidator {
  constructor() {
    this.profiles = null;
    this.currentCart = null;
  }

  /**
   * Fetch active cart limit profiles from metaobjects
   */
  async fetchCartLimitProfiles() {
    const query = `
      query {
        metaobjects(type: "cart_limit_profile", first: 50) {
          nodes {
            id
            fields {
              key
              value
              reference {
                ... on Product {
                  id
                  handle
                }
              }
              references(first: 100) {
                nodes {
                  ... on Product {
                    id
                    handle
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch('/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.Shopify?.storefrontAccessToken || '',
        },
        body: JSON.stringify({ query }),
      });

      const data = await response.json();
      this.profiles = this.parseProfiles(data.data.metaobjects.nodes);
      return this.profiles;
    } catch (error) {
      console.error('Error fetching cart limit profiles:', error);
      return [];
    }
  }

  /**
   * Parse metaobject nodes into usable profile objects
   */
  parseProfiles(nodes) {
    return nodes
      .map(node => {
        const profile = {};
        node.fields.forEach(field => {
          if (field.key === 'name') {
            profile.name = field.value;
          } else if (field.key === 'is_active') {
            profile.isActive = field.value === 'true';
          } else if (field.key === 'limit_type') {
            profile.limitType = field.value;
          } else if (field.key === 'max_quantity') {
            profile.maxQuantity = parseInt(field.value, 10);
          } else if (field.key === 'products') {
            profile.products = field.references?.nodes.map(p => p.id) || [];
          }
        });
        return profile;
      })
      .filter(profile => profile.isActive); // Only return active profiles
  }

  /**
   * Fetch current cart state
   */
  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.currentCart = cart;
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return { items: [] };
    }
  }

  /**
   * Validate if adding a product would exceed limits
   * @param {string} variantId - The variant ID being added
   * @param {number} quantityToAdd - Quantity being added
   * @param {string} productId - Product GID (e.g., gid://shopify/Product/123)
   * @param {number} fallbackMaxQuantity - ri_max_quantity from product metafield
   * @param {boolean} isMembersOnly - Whether product is members-only (ri_members_only)
   * @param {Array} customerTags - Array of customer tags
   * @returns {Object} { valid: boolean, error: string|null }
   */
  async validate(variantId, quantityToAdd, productId, fallbackMaxQuantity = null, isMembersOnly = false, customerTags = []) {
    // Fetch profiles and cart if not already loaded
    if (!this.profiles) {
      await this.fetchCartLimitProfiles();
    }
    if (!this.currentCart) {
      await this.fetchCart();
    }

    // Find matching profiles for this product
    const productProfiles = this.profiles.filter(profile => {
      if (profile.limitType === 'per_product') {
        return profile.products.includes(productId);
      }
      return false;
    });

    // Check per-product limits
    if (productProfiles.length > 0) {
      // Use the strictest (lowest) limit if multiple profiles apply
      const strictestLimit = Math.min(...productProfiles.map(p => p.maxQuantity));
      
      // Calculate current quantity of this product in cart
      const currentQuantity = this.currentCart.items
        .filter(item => item.product_id === this.extractNumericId(productId))
        .reduce((sum, item) => sum + item.quantity, 0);

      const newTotal = currentQuantity + quantityToAdd;

      if (newTotal > strictestLimit) {
        return {
          valid: false,
          error: `Cannot add ${quantityToAdd} item(s). Maximum ${strictestLimit} allowed for this product. You currently have ${currentQuantity} in your cart.`
        };
      }
    } 
    // Fall back to ri_max_quantity metafield if no profile exists
    else if (fallbackMaxQuantity) {
      const currentQuantity = this.currentCart.items
        .filter(item => item.product_id === this.extractNumericId(productId))
        .reduce((sum, item) => sum + item.quantity, 0);

      const newTotal = currentQuantity + quantityToAdd;

      if (newTotal > fallbackMaxQuantity) {
        return {
          valid: false,
          error: `Cannot add ${quantityToAdd} item(s). Maximum ${fallbackMaxQuantity} allowed for this product. You currently have ${currentQuantity} in your cart.`
        };
      }
    }

    // Check total cart limit
    const totalCartProfile = this.profiles.find(profile => profile.limitType === 'total_cart');
    if (totalCartProfile) {
      const currentTotalQuantity = this.currentCart.items.reduce((sum, item) => sum + item.quantity, 0);
      const newTotal = currentTotalQuantity + quantityToAdd;

      if (newTotal > totalCartProfile.maxQuantity) {
        return {
          valid: false,
          error: `Cannot add ${quantityToAdd} item(s). Maximum ${totalCartProfile.maxQuantity} total items allowed in cart. You currently have ${currentTotalQuantity} items.`
        };
      }
    }

    return { valid: true, error: null };
  }

  /**
   * Extract numeric ID from Shopify GID
   * gid://shopify/Product/123 => 123
   */
  extractNumericId(gid) {
    if (!gid) return null;
    const parts = gid.split('/');
    return parseInt(parts[parts.length - 1], 10);
  }

  /**
   * Reset cached data (useful if cart changes externally)
   */
  reset() {
    this.profiles = null;
    this.currentCart = null;
  }
}

// Export singleton instance
window.cartLimitValidator = new CartLimitValidator();